
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import lodash from 'lodash'

@Component({
  components: {}
})
export default class MyTabs extends Vue {
  tabsList: Array<{
    key: string
    path: string
  }> = [
    {
      key: '1',
      path: 'myv2'
    },
    {
      key: '2',
      path: 'myv2-course'
    },
    {
      key: '3',
      path: 'myv2-study'
    },
    {
      key: '4',
      path: 'myv2-account'
    }
  ]
  activeTab: string = '1'

  handleChangeTab(key: string): void {
    if (this.activeTab === key) return

    this.activeTab = key

    let path = lodash.get(
      lodash.find(this.tabsList, item => item.key === key),
      'path',
      'my'
    )

    this.$router.push({ name: path })

    document.documentElement.scrollTo({ top: 0 })
  }

  created(): void {
    const { name } = this.$route

    // 路由替换则删除 -2
    let key = lodash.get(
      lodash.find(this.tabsList, item => item.path === name),
      'key',
      '1'
    )

    this.activeTab = key
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
